import { CurrierStatus } from '@wix/restaurants-types';
import every from 'lodash/every';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import { ACTIVE_CURRIER_INFO_ADDITIONAL_MANDATORY_FIELDS, ACTIVE_CURRIER_INFO_ADDITIONAL_OPTIONAL_FIELDS, BASE_CURRIER_INFO_MANDATORY_FIELDS, BASE_CURRIER_INFO_OPTIONAL_FIELDS } from './constants';
export function toCurrierInfo(customInfo) {
  if (!customInfo) {
    return undefined;
  }
  if (!isAllMandatoryFieldsDefined(customInfo)) {
    return undefined;
  }
  const status = toCurrierStatus(customInfo);
  const isStatusInvalid = !status;
  if (isStatusInvalid) {
    return undefined;
  }
  const {
    providerIconUrl,
    providerName,
    providerSupportUrl,
    providerTrackingUrl,
    providerDashboardUrl,
    providerAppDefId
  } = customInfo.fieldsData;
  const baseCurrierInfo = {
    iconUrl: providerIconUrl,
    name: providerName,
    supportUrl: providerSupportUrl,
    trackingUrl: providerTrackingUrl,
    dashboardUrl: providerDashboardUrl,
    appDefId: providerAppDefId
  };
  const isActiveDelivery = status === CurrierStatus.CREATED;
  if (isActiveDelivery) {
    const isActivePayloadInvalid = !isActiveMandatoryFieldsDefined(customInfo);
    if (isActivePayloadInvalid) {
      return undefined;
    }
    const {
      providerDropOffTime,
      providerPickupTime
    } = customInfo.fieldsData;
    return {
      ...baseCurrierInfo,
      dropOffTime: providerDropOffTime ? new Date(providerDropOffTime) : undefined,
      pickupTime: new Date(providerPickupTime),
      status
    };
  }
  return {
    ...baseCurrierInfo,
    status
  };
}
export function addCurrierInfoData(customInfo, currierInfoData) {
  return {
    fieldsData: {
      ...(customInfo == null ? void 0 : customInfo.fieldsData),
      ...currierInfoData
    }
  };
}
export function clearCurrierInfoData(customInfo) {
  const fieldsData = omit(customInfo.fieldsData, BASE_CURRIER_INFO_MANDATORY_FIELDS, BASE_CURRIER_INFO_OPTIONAL_FIELDS, ACTIVE_CURRIER_INFO_ADDITIONAL_MANDATORY_FIELDS, ACTIVE_CURRIER_INFO_ADDITIONAL_OPTIONAL_FIELDS);
  return isEmpty(fieldsData) ? undefined : {
    fieldsData
  };
}
function toCurrierStatus(customInfo) {
  switch (customInfo.fieldsData.providerStatus) {
    case CurrierStatus.UNINITIALIZED:
      return CurrierStatus.UNINITIALIZED;
    case CurrierStatus.CREATED:
      return CurrierStatus.CREATED;
    case CurrierStatus.REJECTED:
      return CurrierStatus.REJECTED;
    default:
      return undefined;
  }
}
function isAllMandatoryFieldsDefined(customInfo) {
  return isAllFieldsDefined(customInfo, BASE_CURRIER_INFO_MANDATORY_FIELDS);
}
function isActiveMandatoryFieldsDefined(customInfo) {
  return isAllFieldsDefined(customInfo, ACTIVE_CURRIER_INFO_ADDITIONAL_MANDATORY_FIELDS);
}
function isAllFieldsDefined(customInfo, keys) {
  return every(keys, key => {
    return typeof customInfo.fieldsData[key] === 'string';
  });
}
//# sourceMappingURL=index.js.map